import { Injectable, Inject } from '@angular/core';
import * as Immutable from "immutable";
import { AritcoActionCreator } from './aritcoActionCreator';
import { BaseStore, AppStore, HttpAction } from '../state';
import { ConfiguratorStore, ConfPageSessionService, ConfMessageProvider } from '../../configurator/providers';
import { AppStoreSubscriptionManager, ModelFactory } from '../providers';
import { GlobalDataStore } from '../providers/globalData';
import { AritcoResponse, AritcoRequest, ApiResponse } from '../models';
import { ManagedSubject } from '../../../shared';

@Injectable({
  providedIn: 'root',
})
export class AritcoStore extends BaseStore {

  constructor(
    @Inject(AppStore) public appStore: AppStore,
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public storeSession: ConfPageSessionService,
    @Inject(AritcoActionCreator) public actionCreator: AritcoActionCreator,
    @Inject(ConfMessageProvider) public messagesProvider: ConfMessageProvider,
    @Inject(AppStoreSubscriptionManager) public appStoreSubscriptionManager: AppStoreSubscriptionManager,
    @Inject(ModelFactory) public modelFactory: ModelFactory,
    public globalDataStore: GlobalDataStore) {
      super(appStore, appStoreSubscriptionManager, modelFactory, actionCreator);
    }

  public get(aritcoRequest: AritcoRequest): ManagedSubject<AritcoResponse> {

    let action = this.appStore.dispatch(this.actionCreator.get(aritcoRequest)) as HttpAction<ApiResponse>;

    return this.createAction(action, actionInfo => {
      return actionInfo.payload.data as AritcoResponse;
    });

  }

  public updateProgress(): ManagedSubject<AritcoResponse> {

    let aritcoRequest = this.modelFactory.createRequestOrCommand<AritcoRequest>(AritcoRequest.name);
    aritcoRequest.updateProgress = true;

    let action = this.appStore.dispatch(this.actionCreator.get(aritcoRequest)) as HttpAction<ApiResponse>;

    return this.createAction(action, actionInfo => {
      return actionInfo.payload.data as AritcoResponse;
    });

  }
}